module.exports = __webpack_public_path__ + "static/5-4e0e803ccfde27483537ad64e95370bc.jpg";